import exportSubscriber from './exportSubscriber';

export default exportSubscriber;
